export var cloudEventFieldRenameMap = {
  Data: 'data',
  Id: 'id',
  Subject: 'subject',
  Source: 'source',
  Type: 'type',
  comtrbluemoonchainid: 'comTrBluemoon.chainId',
  comtrbluemoonsessionid: 'comTrBluemoon.sessionId',
  comtrbluemoonuserid: 'comTrBluemoon.userId',
  comtrbluemooncontactid: 'comTrBluemoon.contactId',
  comtrbluemooncompanyid: 'comTrBluemoon.companyId',
  comtrbluemoondomain: 'comTrBluemoon.domain',
  Time: 'time',
  Specversion: 'specVersion',
  Datacontenttype: 'dataContentType'
};
export var documentUpdateEventFieldRenameMap = {
  DocumentId: 'documentId',
  EventType: 'eventType',
  InitiatorId: 'initiatorId'
};
